<!-- @format -->

<app-save-modal (onSave)="handleClose()" *ngIf="isExpired"  style="left: 0;" [showCancelButton]="false" [actionButtonTitle]="'Close'" [subTitle]="'The modification window for this form has passed and therefore cannot be edited. Please contact a system administrator'" [title]="'Modification Window Expired'">
</app-save-modal>

<div class="logs-container">
	
	<div class="heading">
		<h2 class="heading">{{ logSheetTemplateName }}</h2>
		<div class="schedule-container">
			<span class="date-error">{{ filterErrorMessage }}</span>
			<div class="label tool-tip">
				<button
					type="button"
					(click)="toggleOverlay()">
					ⓘ
				</button>
				<div
					class="overlay"
					*ngIf="displayOverlay">
						Form Cards will be filtered by scheduled time
				</div>
			</div>
			<div class="date-container">
				<!-- <div
					class="overlay"
					*ngIf="displayOverlay">
					<div class="overlay-header">
						Form Cards will be filtered by scheduled time
					</div>
				</div> -->
				<div class="date-picker">
					<input
						type="date"
						name="startDate"
						(change)="setStartDate()"
						[(ngModel)]="startDate"
						value="startDateFormatted"
						placeholder="Start Date" />
					<span>to</span>
					<input
						type="date"
						name="endDate"
						[min]="startDate"
						(change)="setEndDate()"
						[(ngModel)]="endDate"
						value="endDateFormatted"
						placeholder="End Date" />
				</div>
			</div>
		</div>
	</div>
	<div class="log-container">
		<div
			class="log-item"
			(click)="checkLogsheet(log)"
			[ngClass]="{
				'disable-bg': log.status == 'inProgress' && log.logSheetTemplated.scheduleType.toLowerCase() !== 'ondemand',
				'reposition-container': !log.submittedDate,
				'logsheet-disabled': log.status === 'inProgress' && log.currentUser !== currentUser && role !== Roles.superAdmin && log.logSheetTemplated.scheduleType.toLowerCase() !== 'ondemand'
			}"
			*ngFor="let log of filteredLogs ? filteredLogs : logs; let i = index">
			<div class="log-heading">
				<span class="log-name">
					{{ log.versionNumber > 0 ? log.logSheetTemplated.logSheetName + ' V' + log.versionNumber : log.logSheetTemplated.logSheetName }}
				</span>
				<p class="schedule-type" [ngClass]="getStatusColor(log.status)">{{ getStatusDisplayText(log.status) }}</p>
			</div>
			<div class="log-info log-submitted-info">
				<p class="submitted-date" *ngIf="(log.submittedDate || log.lastModifiedDate) && log.status !== 'available' && log.status !== 'inProgress' && (log.logSheetTemplated.scheduleType !== 'onDemand' || log.isGeneratedOnDemandLogSheet)">
					Last Submitted {{ stringToShortDate(log.submittedDate || log.lastModifiedDate) }} {{ stringToTime(log.submittedDate || log.lastModifiedDate) }}
				</p>
			</div>
<div class="log-info" [ngClass]="(!log.lastModifiedDate || (log.logSheetTemplated.scheduleType === 'onDemand' && !log.isGeneratedOnDemandLogSheet && log.status !== 'inProgress')) ? 'hide-field' : '' ">
				<p *ngIf="log.executedByUserName || log.currentUser" class="current-user">
					<img src="../../../assets/user-log-icon.svg" alt="user-icon" />
					<span class="username-text"
						#usernameExec
						(mouseenter)="isTruncated(usernameExec) && showTooltip('exec-' + i)"
						(mouseleave)="hideTooltip()">
						{{ log.executedByUserName || log.currentUser }}
					</span>
					<span class="username-tooltip" *ngIf="hoveredUsername === 'exec-' + i">{{ log.executedByUserName }}</span>
				</p>
				<p>
					<img
						src="../../../assets/calendar.svg"
						alt="calendar" />{{
							stringToDate(log.executionTime) || stringToDate(log.lastModifiedDate)
					}}
				</p>
				<p>
					<img
						src="../../../assets/clock.svg"
						alt="clock" />{{
							stringToTime(log.executionTime) || stringToTime(log.lastModifiedDate)
					}}
				</p>
			</div>

			<div class="log-edits" *ngIf="log.logSheetTemplated.scheduleType !== 'onDemand' || log.isGeneratedOnDemandLogSheet">
				<div class="edits-container">
					<div>
						<span class="total-edits"
							>{{
								log.adminEditCount + log.nonAdminEditCount || 0
							}}
							edits</span
						>
						<span>{{ log.adminEditCount || 0 }} Admin</span>
						<span>{{ log.nonAdminEditCount || 0 }} Non-Admin</span>
					</div>

					<button 
						type="button"
						(click)="resetLogsheetStatus(log); $event.stopPropagation()"
						class="reset-status"
						*ngIf="log.status == 'inProgress' && (log.currentUser === currentUser || role === Roles.superAdmin)"
					>
						<img
						src="../../../assets/reset-white.svg"
						alt="reset" />
						Reset
					</button>
				</div>
			</div>
		</div>
	</div>
	<div
		class="pagination"
		*ngIf="logs.length !== 0">
		<button
			[style.opacity]="currentPage === 1 ? 0.5 : 1"
			type="button"
			(click)="performDecrement()">
			<img
				class="arrow flipped"
				src="../../assets/triangle-icon.svg"
				alt="navigate back" />
		</button>
		<div *ngFor="let item of loopArray; let i = index">
			<button
				*ngIf="
					item <= totalPages &&
					currentPage > 2 &&
					currentPage < totalPages - 1
						? item >= currentPage - 2 && item <= currentPage + 2
						: currentPage === 1
						? item >= currentPage && item <= currentPage + 4
						: currentPage === 2
						? item >= currentPage - 1 && item <= currentPage + 3
						: currentPage === totalPages - 1
						? item >= currentPage - 3 && item <= currentPage + 1
						: currentPage === totalPages
						? item >= currentPage - 4 && item <= currentPage
						: true
				"
				[style]="currentPage === item ? selectedPage : ''"
				(click)="setCurrentPage(item)"
				class="page-number">
				{{ item }}
			</button>
		</div>
		<button
			[style.opacity]="currentPage === totalPages ? 0.5 : 1"
			type="button"
			(click)="performIncrement()">
			<img
				class="arrow"
				src="../../assets/triangle-icon.svg"
				alt="navigate forward" />
		</button>
	</div>

	<div
		class="center"
		*ngIf="logs.length === 0 && !filteredLogs">
		<app-empty-state [data]="emptyStateLogs" />
	</div>
	<div
		class="center"
		*ngIf="filteredLogs && filteredLogs.length === 0">
		<app-empty-state [data]="emptyFilteredLogs" />
	</div>
</div>
<app-success-toast *ngIf="this.toastService.showToast"></app-success-toast>